<template>
    <div class="app">
        <scroll @refresh="refresh">

            <section>
                <dl class="field" style="height: 65px">
                    <span class="f-strong">订单号：{{orderId}}</span>
                    <dd class="right-item f-strongest">{{totalFee | formatFee}}</dd>
                </dl>
            </section>

            <section class="qrcode-info">
                <div v-show="showQR">
                    <div class="qc-code qrcode-container">
                        <div class="row f-minor" v-show='!isShow'><p style="text-align: center;margin-right: 8px">二维码还有&nbsp;<span class='f-strongest'>{{btnTime}}</span>&nbsp;秒失效!</p></div>
                        <div class="row f-minor" v-show='isShow'><p style="text-align: center">{{btnText}}</p></div>
                        <qrcode :size="175" :cls="qrCls" :value="qrText" style="padding-top: 5px;"></qrcode>
                    </div>
                    <o2o-helper :type="3" :isShow="true" :hasArrow="false" style="padding-top: 5px"></o2o-helper>
                </div>

                <div v-show="showPending">
                    <div class="success-scan"></div>
                    <div class="qc-code qrcode-container scan_succ"></div>
                    <p class="qrcode-instructor f-strong" style="text-align: center">扫码成功!</p>
                    <p class="qrcode-instructor" style="text-align: center">请在自助机上完成支付</p>
                </div>

                <div v-show="showSuccess">
                    <div class="qc-code qrcode-container pay_succ"></div>
                    <p class="qrcode-instructor" style="text-align: center">支付成功</p>
                </div>
                <div class="erweima" v-if='isShow'>
                    <button type="button" class="refresh-btn"  @click="change">刷新二维码</button>
                </div>
            </section>
        </scroll>
    </div>
</template>

<script>

    import Qrcode from 'v-qrcode'
    import O2oHelper from 'O2OHelper'

    export default{
        mounted(){
            var params = this.$store.state.paramModule.param.order.order;
            this.orderId= this.$store.state.paramModule.param.pay.payInfo.orderId;
            this.totalFee = this.$store.state.paramModule.param.order.totalFee;
            this.qrText = params.outerOrderId;
        },
        created(){
            countdown(this);
        },
        data(){
            return {
                totalFee:'',
                qrCls: 'qrcode',
                qrText: '',
                showQR: true,
                showPending: false,
                showSuccess: false,
                btnText:'二维码已失效',
                btnTime:'',
                isShow:false,
                orderId:''
            }
        },
        components: {
            Qrcode,
            O2oHelper
        },
        methods: {
            finished(){
                this.$router.replace('/');
            },
            change(){
                this.isShow = !this.isShow,
                countdown(this)
            }
        }
    }
    var taskId=null;
    function countdown(that){
        var waitTime = 60;
         taskId = setInterval(() => {
            that.btnTime = waitTime
            if (!waitTime) {
                that.isShow=true;
                that.btnText='二维码已失效!';
                that.btnTime='';
                clearInterval(taskId)
            }
            waitTime--
        }, 1000)
    }


</script>
<style lang="scss">
    @import '../../../static/sass/_variable.scss';
    .pay-info {
        padding: 1rem 0.5rem;

    }
    .qrcode-info {
        padding: 0.75rem;
        position: relative;
    }
    .erweima{
        margin-top: 5px;
        height: 175px;
        width: 175px;
        background: url("../../../static/img/mohuewm.png") no-repeat;
        background-size: contain;
        position: absolute;
        top: 12%;
        left: 26%;
    }
    .refresh-btn{
        text-align: center;
        position: absolute;
        background-color: #fff;
        width: 7.75rem;
        height: 2rem;
        border-radius:25px;
        line-height:2rem;
        color:$main-green;
        left: 50%;
        top: 50%;
        @include transform(translate(-50%,-50%));
    }

</style>



// WEBPACK FOOTER //
// SelfPay.vue?722ebd66